import { render } from "./TestLectureList.vue?vue&type=template&id=6854f896&scoped=true"
import script from "./TestLectureList.vue?vue&type=script&lang=js"
export * from "./TestLectureList.vue?vue&type=script&lang=js"

import "./TestLectureList.vue?vue&type=style&index=0&id=6854f896&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6854f896"]])

export default __exports__